// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9b7cec9e","455":"03fb503c","977":"55e2198f"}[chunkId] + ".chunk.js";
};